









import Vue from 'vue';
import CustomType from '../../src/types/vue';


export interface ComponentApp extends Vue {
  langue: string,
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'Langue',
  props: {
    langue: { type: String, required: true },
  },
  data () {
    return {
    }
  },
  methods: {
    isActiveLanguage: function() {
      return this.$language == this.langue
    },
    switchLanguage: function () {  
        this.$store.state.locale =  this.langue;
    },
  },
  components: {
  }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Langue.vue